import clsx from 'clsx';
import Link from 'next/link';
import { FC } from 'react';
import Icon from '~/components/icon';
import ILink from '~/data/strapi/types/shared-components/link';
import sanitizeHtml from '~/utils/sanitize-html';

import styles from './styles.module.css';

interface Props {
  data: ILink;
  isActive: boolean;
}

const HeaderLink: FC<Props> = ({ data, isActive }) => {
  const href = data.href;
  const title = data.title;
  const sublinks = data.links;

  if (!title) {
    return null;
  }

  if (!href)
    return (
      <div className={clsx(styles.link, isActive && styles.active)}>
        {title}
        {sublinks?.length ? <Icon name="chevron" className={styles.icon} /> : <></>}
      </div>
    );

  return (
    <Link className={clsx(styles.link, isActive && styles.active)} href={`/${href}`}>
      <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(title) }} />
      {sublinks?.length ? <Icon name="chevron" className={styles.icon} /> : <></>}
    </Link>
  );
};

export default HeaderLink;
